angular.module('directives.dashboard').controller('wgtSettingsHideTooltipLocation',
    ['$scope', '$rootScope',
        function ($scope, $rootScope) {
            if ($scope.item.setting === undefined) {
                $scope.selectedSettingItem = '';
            } else {
                if(angular.isString($scope.item.setting)){
                    $scope.item.setting = JSON.parse($scope.item.setting);
                }

                $scope.selectedSettingItem = {
                    locationIds : $scope.item.setting.locationIds[0],
                    hideTooltip: $scope.item.setting.hideTooltip
                }
            }
            $scope.saveSettings = function () {
                if ($scope.selectedSettingItem.locationIds === null || $scope.selectedSettingItem.locationIds === undefined || $scope.selectedSettingItem.locationIds === 0) {
                    $scope.$parent.selectedLocation = '';
                    $scope.$parent.selectedLocationId = 0;
                    $scope.$parent.hideTooltip = $scope.selectedSettingItem.hideTooltip ? $scope.selectedSettingItem.hideTooltip: false;
                } else {
                    var location = $.grep($scope.currentUser.locations, function (e) {
                        return e.id === $scope.selectedSettingItem.locationIds;
                    })[0];
                    $scope.$parent.selectedLocation = location.locationName;
                    $scope.$parent.selectedLocationId = location.id;
                    $scope.$parent.hideTooltip = $scope.selectedSettingItem.hideTooltip;

                }
                $scope.selectedSettingItem = {locationIds: [$scope.$parent.selectedLocationId], hideTooltip: $scope.$parent.hideTooltip};
                $scope.item.setting = $scope.selectedSettingItem;
                if ($scope.$parent) {
                    if ($scope.$parent.loadWidget) {
                        $scope.$parent.loadWidget();
                    }
                }
                $rootScope.$emit("widget.changed", $scope.item);

                $scope.$close();
            };
        }]);
